import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import { ProductsIcon } from '../../ui-kit';
import ProductsListView from './ProductsListView';
import ProductCreateView from './ProductCreateView';
import ProductUpdateView from './ProductUpdateView';

const ProductRoute: RouteType = {
    exact: true,
    path: routePaths.products,
    icon:  ProductsIcon,
    title: translate('Products'),
    permissions: {
        backoffice: [BackofficePermission.HasAccess],
    },
    component: ProductsListView,
    childrenRoutes: [
        {
            exact: true,
            title: translate('Create Product'),
            path: routePaths.productsCreate,
            component: ProductCreateView
        },
        {
            exact: true,
            title: translate('Update Product'),
            path: routePaths.productsUpdate,
            component: ProductUpdateView
        }
    ],
};

export default ProductRoute;
